import { render, staticRenderFns } from "./Nomenclature.vue?vue&type=template&id=5856efc6&scoped=true"
import script from "./Nomenclature.vue?vue&type=script&lang=js"
export * from "./Nomenclature.vue?vue&type=script&lang=js"
import style0 from "./Nomenclature.vue?vue&type=style&index=0&id=5856efc6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5856efc6",
  null
  
)

export default component.exports